export default __webpack_public_path__ + "static/media/default-upload.bfb025f4.jpg";